import { useCallback } from 'react';
import { useCreateInviteLinkTeamJoinPostMutation } from '@shared/api';

export const useJoinTeamByToken = () => {
  const [joinToTeamMutation, { isLoading, isError, error }] =
    useCreateInviteLinkTeamJoinPostMutation();

  const joinTeamByToken = useCallback(
    async (token: string) => {
      try {
        await joinToTeamMutation({ bodyCreateInviteLinkTeamJoinPost: { code: token } }).unwrap();
        localStorage.removeItem('pendingInviteToken');
      } catch (err) {
        localStorage.removeItem('pendingInviteToken');
        throw err;
      }
    },
    [joinToTeamMutation],
  );

  return {
    joinTeamByToken,
    isLoading,
    isError,
    error,
  };
};
